import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import packageInfo from '../../package.json';

function BaseLayout() {
  const [version] = useState<any>(packageInfo.version);

  return (
    <>
      <section className="bg-page-background">
        <Outlet />
      </section>
      <div className="fixed bottom-2 right-2 z-50 opacity-40 text-sm">v{version}</div>
    </>
  );
}

export default BaseLayout;
